import { render, staticRenderFns } from "./NoticeCard.vue?vue&type=template&id=c1b98dec&scoped=true"
import script from "./NoticeCard.vue?vue&type=script&lang=js"
export * from "./NoticeCard.vue?vue&type=script&lang=js"
import style0 from "./NoticeCard.vue?vue&type=style&index=0&id=c1b98dec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b98dec",
  null
  
)

export default component.exports